import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import BasePage from '../../baseClasses/BasePage';
import AssignedProjectsCollection from '../../dao/collections/AssignedProjectsCollection';
import dataModel from '../../models/DataModel';
import PageStateDAO from '../../dao/PageStateDAO';
import { PageNames } from '../../constants/ReduxConstants';

import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';

import Home from '../../containers/Home';
import ProjectsList from './ProjectsList';
import MobileHeader from '../../components/MobileHeader';
import MobileSpinner from '../../components/MobileSpinner';
import ProjectListSearch from './ProjectListSearch';

import '../MobileWrapper.scss';
import './ProjectsListWrapper.scss';
import mobileBridge from '../../helpers/MobileBridge';

//const projectDescriptor = { project: { location: { market: {}, users: {}, location_users: { user: { additionalFields: ["profile_image"] } } } } } 
const projectDescriptor = {
  project: {
    location: {
    },
  },
}; 

export class ProjectsListWrapper extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      isRoot: false,
      appliedProjectsFilters: [],
      isFilterApplied: false,
      load: false,
      clear: false,
    };
    const perPage = Math.ceil((window.innerHeight - 96) / 60) + 2;
    this.assignedProjectsCollection = AssignedProjectsCollection.build(perPage, null);
    const currentFilter = this.assignedProjectsCollection.getFilter();
    
    if (this.props.currentUser && this.props.currentCompany){
      if (!currentFilter) {
       
      }
    }
    // don't save filter state
   
    if (currentFilter && currentFilter.statuses) {
      this.assignedProjectsCollection._searchString = '';
      this.assignedProjectsCollection.setFilter({
        statuses: [],
        searchString: '',
      });
    }

    this.statusFilterOptions = [{
      title: 'Project Status',
      initiallyExpanded: true,
      options: [
        { value: 'not_started', name: this.textMap.notStarted, type: 'statuses' },
        { value: 'in_progress', name: this.textMap.inProgress, type: 'statuses' },
        { value: 'complete', name: this.textMap.completed, type: 'statuses' },
      ],
    }];

    // this.offlineFilterOptions=[{
    //   title: 'Offline',
    //   initiallyExpanded:true,
    //   options:[
    //     {value: "offline", name: this.textMap.offline, type: 'statuses'}
    //   ]
    // }]

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    if(localStorage.getItem('projectFilters')){
      let filterArray=localStorage.getItem('projectFilters');
      this.state.appliedProjectsFilters=filterArray!=null? filterArray.split(','):[];
    }
    
    this.fetchData = this.fetchData.bind(this);
    this.formatProjectFilters = this.formatProjectFilters.bind(this);
  }

  componentDidMount() {
    mobileBridge.initialize(this.props.history);
    
    if((localStorage.getItem('projectFilters') || localStorage.getItem('searchStringProject')) && !this.state.isFilterApplied){
      this.state.isFilterApplied=true;
      let filterArray=localStorage.getItem('projectFilters');
      this.assignedProjectsCollection.setFilter({
        statuses: filterArray!=null? filterArray.split(','):[],
        searchString: localStorage.getItem('searchStringProject')?localStorage.getItem('searchStringProject'):'',
      });

      this.state.appliedProjectsFilters=filterArray!=null? filterArray.split(','):[];
      this.fetchData();
    }else{
      this.fetchData();
    }

    // This is separate to handle new assignments made to the current user
    dataModel.actionCableConnector.registerCallback(this.handleActionCableProjectNewAssign, ['newProject', { type: 'updateProject', subType: 'member_assignments' }, { type: 'updateTask', subType: 'task_assignments' }, { type: 'updateTask', subType: 'bulk_assign' }], null, projectDescriptor);
  }

  componentWillUnmount() {
    if (this.projectIds) {
      dataModel.actionCableConnector.unregisterCallback(this.handleActionCableUpdateDeleteProject, ['updateProject', 'deleteProject'], this.projectIds);
    }

    dataModel.actionCableConnector.unregisterCallback(this.handleActionCableProjectNewAssign, ['newProject', { type: 'updateProject', subType: 'member_assignments' }, { type: 'updateTask', subType: 'task_assignments' }, { type: 'updateTask', subType: 'bulk_assign' }], null, projectDescriptor);
    const currentFilter = this.assignedProjectsCollection.getFilter();
    
    if (currentFilter.searchString) {
      this.assignedProjectsCollection.markNeedsSync();
    }
  }

  handleActionCableUpdateDeleteProject(fetchedData, acData) {
    this.fetchData();
  }

  handleActionCableProjectNewAssign(fetchedData, acData) {
    // is it one I care about?
    if (fetchedData.users) {
      if (fetchedData.users.find(userId => { return userId == this.props.currentUser.id; })) {
        this.fetchData();
      }
    }
    else if (fetchedData.user_task_assignments) {
      if (fetchedData.user_task_assignments.find(uta => { return uta.user_id == this.props.currentUser.id; })) {
        this.fetchData();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionCableUpdate != this.props.actionCableUpdate) {
      this.setState({ actionCableUpdate: this.props.actionCableUpdate });
    }
    if ((this.props.currentUser && (!prevProps.currentUser || prevProps.currentUser.id != this.props.currentUser.id))
        || (this.props.online != prevProps.online && this.props.online)) {       
      this.fetchData();
    }

    if((localStorage.getItem('projectFilters') || localStorage.getItem('searchStringProject')) && !this.state.isFilterApplied){
      this.state.isFilterApplied=true;
      let filterArray=localStorage.getItem('projectFilters');
      this.assignedProjectsCollection.setFilter({
        statuses: filterArray!=null? filterArray.split(','):[],
        searchString: localStorage.getItem('searchStringProject')?localStorage.getItem('searchStringProject'):'',
      });
      this.state.appliedProjectsFilters=filterArray!=null? filterArray.split(','):[];
      this.fetchData();
    
    } 
  }

  fetchData() {
    if (this.projectIds) {
      dataModel.actionCableConnector.unregisterCallback(this.handleActionCableUpdateDeleteProject, ['updateProject', 'deleteProject'], this.projectIds, projectDescriptor);
    }
    let perPage=localStorage.getItem('perPage')?parseInt(localStorage.getItem('perPage'),10):15;
    let total_favorite_projects=localStorage.getItem('favorite_projects') && localStorage.getItem('favorite_projects')>15?
    parseInt(localStorage.getItem('favorite_projects'),10):15;

    if (total_favorite_projects> perPage){
      perPage=total_favorite_projects;
    }
    this.assignedProjectsCollection.fetchCurrent(true, { recordDescriptor: projectDescriptor,perPage },).then(myProjects => {
      this.projectIds = myProjects.projects.map(project => {
        return project.id;
      });
      let filterArray = [];
      if (myProjects._filter && myProjects._filter.statuses && myProjects._filter.statuses.length) {
        filterArray = myProjects._filter.statuses;
      }
      if (this.projectIds && this.projectIds.length > 0) {
        dataModel.actionCableConnector.registerCallback(this.handleActionCableDeleteProject, ['updateProject', 'deleteProject'], this.projectIds, projectDescriptor);
      }
      this.setState({ myProjects, appliedProjectsFilters: filterArray });
      localStorage.setItem('projectList',JSON.stringify({ projects: this.state.myProjects }));

    });
    
  }

  formatProjectFilters(filterArray) {
    const formattedFilters = filterArray.map(filter => {
      if (filter == 'completed') return 'complete';
      else return filter;
    });
    return formattedFilters;
  }

  handleApplyFilters(filterArray) {
    filterArray = filterArray.statuses ? filterArray.statuses : [];
    this.setState({ appliedProjectsFilters: filterArray });
    const filter = this.assignedProjectsCollection.getFilter();
    filter.statuses = this.formatProjectFilters(filterArray);
    this.assignedProjectsCollection.setFilter(filter);
    this.fetchData();
  };

  handleAppliedFilters(filters){
    localStorage.setItem('projectFilters',filters);
    this.state.isFilterApplied=true;
   //localStorage.setItem('perPage',localStorage.getItem(''))
  }

  handleClear() {
    this.setState({ appliedProjectsFilters: [] });
    
    //filter.searchString = ""
    this.assignedProjectsCollection.setFilter({
      statuses: [],
    });

    this.fetchData();
    //Remove persistent data
    delete localStorage.projectFilters;
    delete localStorage.projectList;
    delete localStorage.scrollPosition;
  }

  handleProjectSearch(searchString) {
    const filter = this.assignedProjectsCollection.getFilter();
    filter.searchString = searchString;
    this.assignedProjectsCollection.setFilter(filter);
    this.fetchData();
  }

  handleLoadMore() {
    // TODO: only fetch next if we have not fetched all
    let perPage=localStorage.getItem('perPage')?localStorage.getItem('perPage'):15;
    let total_projects=localStorage.getItem('total_projects')?
    localStorage.getItem('total_projects'):15;

    if (total_projects> perPage && (localStorage.getItem('projectFilters') || localStorage.getItem('searchStringProject'))){
      perPage=total_projects;
    }else if(total_projects> perPage){
      perPage=total_projects;
    }
    return this.assignedProjectsCollection.fetchNext(true, { recordDescriptor: projectDescriptor ,perPage })
    .then(myProjects => {
      this.setState({ myProjects });
      this.state.load=true;
      let count=this.state.myProjects.projects.length;
      if(this.state.myProjects.projects.length< parseInt(localStorage.getItem('perPage'),10)){
        count= localStorage.getItem('perPage');
      }
      localStorage.setItem('perPage',count);
    });
  }

  handleFavoriteProject(e, project) {
    e.stopPropagation();

    const favoriteFlagValue = !project.is_favorite;
    if (favoriteFlagValue) {
      this.analyticsLogger.logProjectListEvent('ProjectListFavorite');
    }
    else {
      this.analyticsLogger.logProjectListEvent('ProjectListUnfavorite');
    }
    dataModel.projectsDAO.setFavoriteProject(project.id, favoriteFlagValue, null, { recordDescriptor: { project: { location: { market: {}, users: {}, location_users: { user: { additionalFields: ['profile_image'] } } } } } })
      .then(result => {
        if (favoriteFlagValue && this.props.currentUser) {
          // fetch favorites to ensure data is available should we go offline
          dataModel.projectsDAO.fetchFavorites(this.props.currentUser.id);
        }
        let perPage;
        if(localStorage.getItem('perPage')){
          perPage = localStorage.getItem('perPage');
        }else{perPage =localStorage.getItem('favorite_projects') && localStorage.getItem('favorite_projects') >13? localStorage.getItem('favorite_projects'):13;}
        return this.assignedProjectsCollection.fetchCurrent(true, { recordDescriptor: projectDescriptor,perPage });
      })
      .then(myProjects => {
        this.setState({ myProjects });
      });
  }

  handleSelectProject(project) {
    this.analyticsLogger.logProjectListEvent('ProjectSelected');
    //set the Details tab as selected tab on PageStateDAO
    PageStateDAO.setPageStateEntry(PageNames.MOBILE_PROJECT_DETAIL, 'tabSelected', 'Details');
    this.props.history.push({
      pathname: '/mobile/projects/' + project.id,
      state: { 
        projectName: project.name, 
        projectStatus: project.status,
      },
    });
  }

  render() {
    let {
      currentUser,
      currentCompany,
      permissions,
      systemPopup,
    } = this.props;

    const { myProjects, appliedProjectsFilters } = this.state;
    let waitSpinner = null;
    if (this.state.navPath) {
      this.props.history.push({ pathname: this.state.navPath });
    }

    if (!myProjects) {
      waitSpinner = <Home type="transparent" />;
    }

    if (!currentUser || !currentCompany || !permissions) {
      return <Home type={'projects'} message={'Awaiting Initialization'} />;
    }

    this.setWhiteLabels(currentCompany);

    if (!myProjects) {
      return (
        <div className='mobile-wrapper'>
          <MobileHeader
            headerTitle={'Projects'}
            rootPage={this.props.rootPage}
            noBackButton={true}
            hasFilters={true}
            filterOptions={this.statusFilterOptions}
            handleClear={this.handleClear}
            appliedFilters={{ statuses: appliedProjectsFilters }}
            applyFilters={this.handleApplyFilters}
            // offlineFilter={this.offlineFilterOptions}
          />
          <MobileSpinner />
        </div>
      );
    }
 
    return (
      <div className='mobile-wrapper'>
        <MobileHeader
          headerTitle={'Projects'}
          rootPage={this.props.rootPage }
          noBackButton={true}
          hasFilters={true}
          filterOptions={this.statusFilterOptions}
          handleClear={this.handleClear}
          appliedFilters={{ statuses: appliedProjectsFilters }}
          applyFilters={this.handleApplyFilters}
          // offlineFilter={this.offlineFilterOptions}
          handleAppliedFilters={this.handleAppliedFilters}
        />
        {systemPopup}
        {waitSpinner}
        <div className="content-wrapper">
          <ProjectListSearch handleProjectSearch={this.handleProjectSearch} searchString={this.assignedProjectsCollection.getFilter().searchString}/>
          <ProjectsList 
            myProjects={myProjects} 
            handleFavoriteProject={this.handleFavoriteProject}
            handleSelectProject={this.handleSelectProject}
            handleLoadMore={this.handleLoadMore}
          />
        </div>
      </div>
    );
  }
}

ProjectsListWrapper.defaultProps = {
  rootPage: false,
};

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    actionCableUpdate: state.main.actionCableUpdate,
    currentCompany: state.new_companies.currentCompany,
    online: state.main.online,
    navigateUri: state.main.navigateUri,
    systemPopup: state.main.systemPopup,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectsListWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/ProjectsListWrapper/index.js